// extracted by mini-css-extract-plugin
export var forgotPasswordLink = "TkjvqEv91td_3LqRD4L4";
export var passwordForm = "yGmW6jZ2skML_l4KZiub";
export var passwordFormButtons = "rskQJHM_33gEDm6d747x";
export var passwordFormDescription = "SZaTo50wqin14B19oV7A";
export var passwordScreenHeading = "rV_pE9aNuXz9R_xmk7em";